import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, setPaginaAcesso } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setUser } from "../redux/slices/persisted/persistedSlice";
import { setModalAlterarSenhaUsuario, setModalCadastrarUsuario, setModalDeletarUsuario, setModalPermissaoUsuario } from "../redux/slices/account/accountSlice";

export const cadastrarUsuario = createAsyncThunk("/Account/CadastrarUsuario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Account/CadastrarUsuario", payload.value);
    toastSucess("Usuário cadastrado com sucesso");
    dispatch(setModalCadastrarUsuario(false));
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const login = createAsyncThunk("/Account/Login", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const data = await api.post("/Account/Login", payload.value);
    const response = data.data.data;
    if (response.perfis !== null && response.perfis.length > 1) {
      dispatch(setPaginaAcesso("perfil"));
    } else {
      payload.navigate("/painelGeral");
    }
    dispatch(setUser(data.data.data));
    toastSucess("Login realizado com sucesso!");
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const alterarSenhaUsuario = createAsyncThunk("/Account/AlterarSenhaUsuario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Account/AlterarSenhaUsuario", payload.value);
    toastSucess("Senha do usuário alterada com sucesso");
    dispatch(setModalAlterarSenhaUsuario(false));
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarRole = createAsyncThunk("/Account/ListarRole", async () => {
  try {
    const data = await api.get("/Account/ListarRole");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarUsuario = createAsyncThunk("/Account/BuscarUsuario", async (textoBusca: string | null) => {
  try {
    const data = await api.get("/Account/BuscarUsuario", {
      params: { textoBusca: textoBusca },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarUsuario = createAsyncThunk("/Account/AtualizarUsuario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Account/AtualizarUsuario", payload.value);
    toastSucess("Usuário atualizado com sucesso");
    dispatch(setModalCadastrarUsuario(false));
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarUsuarioAtivo = createAsyncThunk("/Account/AtualizarUsuarioAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Account/AtualizarUsuarioAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo do usuário atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarUsuarioEmpresa = createAsyncThunk("/Account/AtualizarUsuarioEmpresa", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Account/AtualizarUsuarioEmpresa", payload.value);
    toastSucess("As permissões do usuário foram alteradas com sucesso");
    dispatch(setModalPermissaoUsuario(false));
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarUsuario = createAsyncThunk("/Account/DeletarUsuario", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Account/DeletarUsuario", {
      data: payload.value,
    });
    toastSucess("Usuário removido com sucesso");
    dispatch(setModalDeletarUsuario(false));
    dispatch(setLoading(false));

    dispatch(buscarUsuario(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
